import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Grid, Paper, useMediaQuery } from '@mui/material';
import Titlebar from '../TitleBar';
import { Pagination, SearchTable, TableBody2, TableBody4, TableBottom, TableBottom3, TableHeader } from '.';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import { applyFilter, emptyRows, getComparator, extractDate } from '../../Utils/table';
import { AdminSaleMenu, adminSaleReport, StkInwMenu } from '../TitleList';
import { selectAdminSaleData, selectLocations, selectZones } from '../Selectors/Master/OutwardSelectors';
import { fetchAdminSaleData, fetchAdminSaleReport } from '../../Store/PHPSlice/stockApi';
import DateInputComponent2 from '../FieldsComponents/DateInputComponent2';
import styled, { inputStyles } from '../../Utils/inputChanges';
import Dropdown from '../FieldsComponents/Dropdown';
import { fetchZoneData } from '../../Store/PHPSlice/zone';
import { fetchLocationData } from '../../Store/PHPSlice/LocationApi';
import axios from 'axios';
import RadioComponent from '../FieldsComponents/RadioComponent';


const AdminItemReport = () => {
    const dispatch = useDispatch();
    const getItems = useSelector(selectAdminSaleData);
    const zones = useSelector(selectZones);
    const schools = useSelector(selectLocations);
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const isDesktop = useMediaQuery('(min-width:768px)');
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('empId');
    const [selected, setSelected] = useState([]);
    const [filterName, setFilterName] = useState('null');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");
    const [firstIndex, setFirstIndex] = useState(0);
    const [lastIndex, setLastIndex] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [pageRange, setPageRange] = useState([0, 10]); // Initial range [0, 10]
    const [searchTerm, setSearchTerm] = useState('');

    const [formData, setFormData] = useState({
        fdt: '',
        tdt: '',
        itemId: '',
        schlId: '',
        type: 'admin'
    });

    const [reportData, setReportData] = useState([]);

    const [itemData, setItemData] = useState([]);

    useEffect(() => {
        fetchAdminStkItems();
        dispatch(fetchLocationData());
    }, []);

    const fetchAdminStkItems = async () => {
        try {
            const response = await axios.get(`${baseUrl}?apicall=getAdminStockItemsList`);
            setItemData(response?.data?.data);
            // console.log(response?.data);
        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    const fetchAdminItemWiseData = async (formData) => {
        try {
            const response = await axios.post(`${baseUrl}?apicall=getAdminReportItemWise`, formData);
            setReportData(response?.data);
            // console.log(response?.data);
        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    if (!reportData) {
        return <h1>Loading...</h1>;
    }

    // console.log(reportData.data)

    const compData = Array.isArray(reportData?.data) ? reportData?.data?.map((item, index) => (
        {
            srNo: item.ID,
            billNo: item.billNo,
            itemNm: item.itemNm,
            itemId: item.itemId,
            size: item.size,
            qty: item.qty,
            bqty: item.bqty,
            sqty: item.sqty,
            amt: item.amt,
            srate: item.srate,
            prate: item.prate,
            schlId: item.schlId,
            schlNm: item.schlNm,
            schlcd: item.schlcd,
            adsid: item.sId,
            serialNumber: index + 1
        }
    )) : [];


    const handleSort = (event, id) => {
        const isAsc = orderBy === id && order === 'asc';
        if (id !== '') {
            setOrder(isAsc ? 'desc' : 'asc');
            setOrderBy(id);
        }
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = compData.map((n) => n.name);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }
        setSelected(newSelected);
    };


    const totalCount = compData.length;
    const npages = Math.ceil(totalCount / recordsPerPage);
    const numbers = Array.from({ length: npages }, (_, i) => i + 1);

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reset to first page on search
    };

    const filteredData = (Array.isArray(compData) ? compData : []).filter(item =>
        item?.itemNm?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const totstkqty = filteredData?.reduce((acc, sum) => acc + parseFloat(sum.qty), 0);
    const totsaleqty = filteredData?.reduce((acc, sum) => acc + parseFloat(sum.sqty), 0);
    const totbalqty = filteredData?.reduce((acc, sum) => acc + parseFloat(sum.bqty), 0);
    const totprate = filteredData?.reduce((acc, sum) => acc + parseFloat(sum.prate), 0);
    const totsrate = filteredData?.reduce((acc, sum) => acc + parseFloat(sum.srate), 0);
    const totamt = filteredData?.reduce((acc, sum) => acc + parseFloat(sum.amt), 0);

    // console.log(compData);
    const dataFiltered = applyFilter({
        inputData: filteredData,
        comparator: getComparator(order, orderBy),
    });

    const totalPages = Math.ceil(dataFiltered.length / itemsPerPage);
    const displayedData = dataFiltered.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);
    const visiblePageNumbers = pageNumbers.slice(pageRange[0], pageRange[1]);

    const handleNextPageRange = () => {
        setPageRange([pageRange[0] + 5, pageRange[1] + 5]);
    };

    const handlePreviousPageRange = () => {
        setPageRange([pageRange[0] - 5, pageRange[1] - 5]);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(Number(event.target.value));
        setCurrentPage(1); // Reset to first page on change
    };
    // console.log(displayedData);

    const fields = [
        { label: 'From Date', name: 'fdt', type: 'date' },
        { label: 'To Date', name: 'tdt', type: 'date' },
        // { label: 'Barcode', name: 'freight_ch' },
    ];

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
    };


    const dropdownOrdType = [
        {
            label: 'Item',
            id: 'itemId',
            options: itemData || [],
            value: formData.itemId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'itemId', value: newValue ? newValue.ID : '' } }, 'itemId'),
            getOptionLabel: (option) => option.itemNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            bold: true,
        }
    ];

    const dropdownOrdType2 = [
        {
            label: 'School',
            id: 'schlId',
            options: schools?.data || [],
            value: formData.schlId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'schlId', value: newValue ? newValue.ID : '' } }, 'schlId'),
            getOptionLabel: (option) => option.schlcd || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            bold: true,
        }
    ];

    const typesoption = [
        { label: 'Admin', value: 'admin' },
        { label: 'School', value: 'school' }
    ];

    const handleRadioChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSearch = (e) => {
        e.preventDefault();
        // if (!formData.itemId || !formData.schlId) {
        //     // If any field is empty, stop the function
        //     alert('Select Item');
        //     return;
        // }
        fetchAdminItemWiseData(formData);
    };
    return (
        <>
            <Titlebar data={adminSaleReport} />

            <div style={{ margin: '1% 0.5%' }}>
                <h2>Item Wise Sale Report</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>

                            <Grid container spacing={0.5}>
                                {fields.map((field) => (
                                    <DateInputComponent2
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleInputChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}

                                {/* <RadioComponent
                                    options={typesoption}
                                    label='Type'
                                    value={formData.type}
                                    name='type'
                                    isDesktop={isDesktop}
                                    onChange={handleRadioChange}
                                /> */}

                                {
                                    dropdownOrdType?.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here

                                        />
                                    ))
                                }

                                {
                                    dropdownOrdType2?.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here

                                        />
                                    ))
                                }



                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSearch}>Search</Button>
                                </Grid>
                            </Grid>

                            <Grid item xs={12} textAlign="center" style={{ marginTop: '4%' }}>
                            </Grid>
                            <SearchTable
                                handleItemsPerPageChange={handleItemsPerPageChange}
                                searchTerm={searchTerm}
                                handleSearchChange={handleSearchChange}
                                totalItems={filteredData?.length}
                            />


                            <TableContainer style={{ marginTop: '2%', border: '1px solid #ccc' }}>
                                <Table>
                                    <TableHeader
                                        headCells={[
                                            { id: 'srNo', label: 'Sr.No' },
                                            { id: 'billNo', label: 'Bill No' },
                                            { id: 'schlNm', label: 'School' },
                                            { id: 'itemNm', label: 'Item' },
                                            // { id: 'size', label: 'Size' },
                                            { id: 'qty', label: 'Stock Qty' },
                                            { id: 'sqty', label: 'Sale Qty' },
                                            { id: 'bqty', label: 'Bal Qty' },
                                            // { id: 'srate', label: 'Sale Rate' },
                                            // { id: 'prate', label: 'Purchase Rate' },
                                            { id: '', label: 'View' },
                                            // { id: 'edit', label: 'Edit' },
                                            // { id: 'delete', label: 'Delete' }
                                        ]}

                                        order={order}
                                        orderBy={orderBy}
                                        onRequestSort={handleSort}
                                        numSelected={selected.length}
                                        rowCount={compData.length}
                                        onSelectAllClick={handleSelectAllClick}
                                    />
                                    <tbody>
                                        {displayedData && displayedData.length > 0 ? (
                                            <>
                                                {displayedData?.map((row, idx) => (
                                                    <TableBody4
                                                        key={row.srNo}
                                                        id={row.srNo}
                                                        adsid={row.adsid}
                                                        billNo={row.billNo}
                                                        itemId={row.itemId}
                                                        itemNm={row.itemNm}
                                                        size={row.size}
                                                        schlId={row.schlId}
                                                        schlNm={row.schlNm}
                                                        schlcd={row.schlcd}
                                                        qty={row.qty}
                                                        bqty={row.bqty}
                                                        sqty={row.sqty}
                                                        amt={row.amt}
                                                        srate={row.srate}
                                                        prate={row.prate}
                                                        fdt={formData.fdt}
                                                        tdt={formData.tdt}
                                                        serialNumber={row.serialNumber}
                                                        selected={selected.indexOf(row.name) !== -1}
                                                        handleClick={(event) => handleClick(event, row.name)}
                                                    />
                                                ))}
                                                <TableBottom3
                                                    totsaleqty={totsaleqty}
                                                    totstkqty={totstkqty}
                                                    totamt={totamt}
                                                    totbalqty={totbalqty}
                                                    totsrate={totsrate}
                                                    totprate={totprate}
                                                />
                                            </>
                                        ) : (
                                            <tr>
                                                <td colSpan={12} style={{ textAlign: "center", padding: "10px" }}>
                                                    No data available
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </TableContainer>

                            <Pagination
                                currentPage={currentPage}
                                handlePageChange={handlePageChange}
                                handlePreviousPageRange={handlePreviousPageRange}
                                visiblePageNumbers={visiblePageNumbers}
                                pageNumber={pageNumbers}
                                pageRange={pageRange}
                                totalPages={totalPages}
                                handleNextPageRange={handleNextPageRange}
                            />
                        </Paper>
                    </Grid>
                </Grid>
            </div>

        </>
    );
}

export default AdminItemReport;
